import { t } from '@/features/i18n/utils';
import { useAuth } from '@/features/auth';
import { OrganizationAvatar } from '@/features/organizations/components/organization-avatar';
import { useSwitchOrganization } from '@/features/user/mutations';
import { Link } from '@tanstack/react-router';
import { Badge } from '@/ui/components/badge';
import {
  MenuItem,
  MenuPopup,
  MenuRadioGroup,
  MenuRadioItem,
  MenuSeparator,
  MenuSubmenuTrigger,
  Submenu,
} from '@/ui/components/menu';

export function SwitchOrganizationMenu() {
  const auth = useAuth();
  const switchOrganization = useSwitchOrganization();

  return (
    <>
      <Submenu>
        <MenuSubmenuTrigger>
          {t({ en: 'Switch organisation', nb: 'Bytt organisasjon' })}
        </MenuSubmenuTrigger>
        <MenuPopup>
          <MenuRadioGroup
            value={auth.user.organizationId}
            onValueChange={(value) => switchOrganization.mutate(value)}
          >
            {auth.user.organizations.map((org) => (
              <MenuRadioItem
                key={org.organizationId}
                value={org.organizationId}
                disabled={!org.isEnabled || switchOrganization.isPending}
              >
                <OrganizationAvatar
                  organization={{ id: org.organizationId, name: org.organizationName }}
                  size={20}
                  className="rounded-[calc(var(--radius-md)-0.125rem)]"
                />
                <span className="truncate">{org.organizationName}</span>
                {!org.isEnabled ? (
                  <Badge size="xxs" variant="tertiary-warning" className="ml-auto">
                    {t({ en: 'Pending approval', nb: 'Venter på godkjenning' })}
                  </Badge>
                ) : null}
              </MenuRadioItem>
            ))}
          </MenuRadioGroup>
          <MenuSeparator />
          <MenuItem render={<Link to="/add-organization" />} nativeButton={false}>
            {t({ en: 'Create an organisation...', nb: 'Opprett organisasjon...' })}
          </MenuItem>
        </MenuPopup>
      </Submenu>
      <MenuSeparator />
    </>
  );
}
